// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"495":"bccfd6e8","532":"02491b4d","756":"2f96a4f1","787":"afb12b21","938":"27f2f648"}[chunkId] + ".chunk.js";
};